import React from "react";
import { Grid } from '@mui/material';
import './styles.css';
import useFlightsSearch from "../../../viewModels/flights/flights.search.viewModel";
import FlightDetailFilter from "../components/flightDetailResultFilter";
import FlightDetailResultsList from "../components/flightDetailResultsList";

function Flights() {
  const {
    loading,
    isRoundTrip, setIsRoundTrip,
    nameOrigin, setNameOrigin,
    nameDestiny, setNameDestiny,
    getFlights,
    queryError,
    flightsList,
    airlinesList,
    allPassengersSelected,
    setAllPassengersSelected,
    setDateGoingSelected,
    setDateGoingSelectedApi,
    setDateReturnSelected,
    setDateReturnSelectedApi,
    dateReturnSelected,
    dateGoingSelected,
  } = useFlightsSearch();
  return (
    <Grid container justifyContent='center'>
      <div className='flightSelectedDetail'>
        <FlightDetailFilter
          isRoundTrip={isRoundTrip}
          setIsRoundTrip={setIsRoundTrip}
          origin={nameOrigin}
          setOrigin={setNameOrigin}
          destiny={nameDestiny}
          setDestiny={setNameDestiny}
          getFlights={getFlights}
          loading={loading}
          allPassengersSelected={allPassengersSelected}
          setAllPassengersSelected={setAllPassengersSelected}
          setDateGoingSelected={setDateGoingSelected}
          setDateGoingSelectedApi={setDateGoingSelectedApi}
          setDateReturnSelected={setDateReturnSelected}
          setDateReturnSelectedApi={setDateReturnSelectedApi}
          dateReturnSelected={dateReturnSelected}
          dateGoingSelected={dateGoingSelected}
        />
        <FlightDetailResultsList
          allPassengersSelected={allPassengersSelected}
          queryError={queryError}
          isRoundTrip={isRoundTrip}
          loading={loading}
          flightsList={flightsList}
          nameOrigin={nameOrigin}
          nameDestiny={nameDestiny}
        />
      </div>
    </Grid>
  )
}

export default Flights;